import { createActions } from "../../helpers/utils/createActions";
import { SNIPPETS } from "./actionTypes";

export const getListaSnippet = createActions(SNIPPETS.GET_LIST_SNIPPET);
export const getSnippet = createActions(SNIPPETS.GET_SNIPPET);
export const saveSnippet = createActions(SNIPPETS.SAVE_SNIPPET);
export const duplicateSnippet = createActions(SNIPPETS.DUPLICATE_SNIPPET);

export const getSnippetHistoryList = createActions(SNIPPETS.GET_SNIPPET_HISTORY_LIST);
export const getSnippetHistory = createActions(SNIPPETS.GET_SNIPPET_HISTORY);
export const getSnippetAll = createActions(SNIPPETS.GET_SNIPPET_ALL);

export const getSnippetProducts = createActions(SNIPPETS.GET_SNIPPET_PRODUCTS);
export const getSnippetSections = createActions(SNIPPETS.GET_SNIPPET_SECTIONS);

export const getSnippetPreview = createActions(SNIPPETS.GET_SNIPPET_PREVIEW);

export const postSnippetDownloadList = createActions(SNIPPETS.POST_SNIPPET_DOWNLOAD_LIST);

export const loadEmptySnippet = () => ({ type: SNIPPETS.LOAD_EMPTY });
export const cleanMessageSnippet = () => ({ type: SNIPPETS.CLEAN_MESSAGE });
export const cleanIdSnippetDuplicate = () => ({ type: SNIPPETS.CLEAN_ID_SNIPPET_DUPLICATE });
export const changePageSizeSnippet = (payload) => ({ type: SNIPPETS.CHANGE_PAGE_SIZE_SNIPPET, payload });